import { render, staticRenderFns } from "./list_cus_joined.vue?vue&type=template&id=2bf168ae&scoped=true"
import script from "./list_cus_joined.vue?vue&type=script&lang=js"
export * from "./list_cus_joined.vue?vue&type=script&lang=js"
import style0 from "./list_cus_joined.vue?vue&type=style&index=0&id=2bf168ae&prod&lang=css&scoped=true"
import style1 from "./list_cus_joined.vue?vue&type=style&index=1&id=2bf168ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf168ae",
  null
  
)

export default component.exports